(() => {
  const setup = (root = document) => root.querySelectorAll('announcement-bar[data-lm-offer]').forEach((bar) => {
    if (bar.dataset.lmReady) return;
    bar.dataset.lmReady = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const toggle = bar.querySelector('[data-lm-pause]');
    let paused = false;
    let reducedOverride = false;
    let hovered = false;
    let focused = false;
    const sync = () => {
      const autoplay = bar.carousel?.slider?.autoplay;
      const motionPaused = reduced.matches && !reducedOverride;
      const stop = paused || motionPaused || hovered || focused;
      if (stop) autoplay?.stop();
      else if (bar.dataset.lmRotate === 'true') autoplay?.start();
      if (toggle) {
        toggle.setAttribute('aria-pressed', String(paused || motionPaused));
        toggle.setAttribute('aria-label', paused || motionPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        toggle.textContent = paused || motionPaused ? '▶' : 'Ⅱ';
      }
    };
    if (reduced.matches) bar.removeAttribute('autoplay');
    toggle?.addEventListener('click', () => { if(reduced.matches && !reducedOverride){reducedOverride=true;paused=false;}else{paused=!paused;} sync(); });
    bar.addEventListener('mouseenter', () => { hovered = true; sync(); });
    bar.addEventListener('mouseleave', () => { hovered = false; sync(); });
    bar.addEventListener('focusin', () => { focused = true; sync(); });
    bar.addEventListener('focusout', () => { setTimeout(() => { focused = bar.contains(document.activeElement); sync(); }, 0); });
    reduced.addEventListener('change', () => { reducedOverride=false; sync(); });
    let attempts = 0;
    const ready = () => {
      sync();
      if (!bar.hasAttribute('data-lm-single') && !bar.carousel?.slider && ++attempts < 50) setTimeout(ready, 100);
    };
    ready();
    bar.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-lm-copy]');
        if(!button || !bar.contains(button)) return;
        const original = button._lmOriginalHtml ??= button.innerHTML;
        const code = button.dataset.lmCopy;
        const live = bar.querySelector('[data-lm-feedback]');
        try {
          if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(code);
          else {
            const input = document.createElement('textarea');
            input.value = code;
            input.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
            document.body.append(input); input.select();
            const ok = document.execCommand('copy'); input.remove();
            if (!ok) throw new Error('copy');
            button.focus();
          }
          button.textContent = button.dataset.copiedLabel;
          if (live) live.textContent = button.dataset.copiedLabel;
          clearTimeout(button._lmRestore);
          button._lmRestore = setTimeout(() => { button.innerHTML = original; if(live) live.textContent = ''; }, 1800);
        } catch (_) {
          if (live) live.textContent = button.dataset.copyError;
        }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', e => setup(e.target));
})();
